import { useState, useEffect } from 'react'
import api, { IUsageType } from '@api'

let persistedUTState: IUsageType[] = []

export default function useUsageTypes(): IUsageType[] {
  const [usageTypes, setUsageTypes] = useState<IUsageType[]>(persistedUTState)

  useEffect(() => {
    api.company.usageTypes().then((usageTypes) => setUsageTypes(usageTypes))
  }, [])

  useEffect(() => {
    // Cache initial list
    if (!persistedUTState.length && usageTypes.length) {
      persistedUTState = usageTypes
    }
  })

  return usageTypes
}
